import type { AxiosRequestConfig } from "axios";

import request from "@/plugins/axios";

import UserCenterEnum from "@/api/userCenter/enums";
import axios from "axios";

const isDev =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";
const url = !isDev ? "" : "/api";

/**
 * 查询用户钱包余额
 */
export function getWalletBalance() {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.MY_WALLET_BALANCE}`,
    method: "post",
  };
  return request(config);
}

/**
 * 提现
 */
export function withdraw(params: { amount?: number; token?: string }) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.WITHDRAW}`,
    method: "post",
    data: params,
  };
  return request(config);
}
export type TransactionDetailParams = {
  pageNo?: number;
  pageSize?: number;
};
export type TradedParams = {
  pageNo?: number;
  pageSize?: number;
  name?: string;
};
/**
 * 交易明细
 */
export function getTransactionDetail(params: TransactionDetailParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.TRANSACTION_DETAIL}`, //我的钱包
    method: "post",
    data: params,
  };
  return request(config);
}
/**
 * 交易记录
 */
export function getTradedList(params: TradedParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.TRADED_LIST}`,
    method: "post",
    data: params,
  };
  return request(config);
}
export function getFirmTradedList(params: TradedParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.FIRM_RADED_LIST}`,
    method: "post",
    data: params,
  };
  return request(config);
}
/**
 * 开通个人账户
 */
export type AuthenticationParams = {
  // name: string;
  // idNumber: string;
  bankCode: string;
  telphone: string;
  idNumberPortrait: File;
  idNumberEmblem: File;
};
export function goAuthentication(params: AuthenticationParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.AUTHENTICATION}`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    method: "post",
    data: params,
  };
  return request(config);
}

/**
 * 查询用户开户信息
 */
export function queryUserInfo() {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.QUERY_USER_INFO}`,
    method: "post",
  };
  return request(config);
}

/**
 * 查询我的报告审核列表
 */
export type AssessmentReportListParams = {
  pageNo?: number;
  pageSize?: number;
  name?: string;
};
export function getAssessmentReportList(params: AssessmentReportListParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.ASSESSMENT_REPORT_LIST}`,
    method: "post",
    data: params,
  };
  return request(config);
}
/**
 * 查询我的订单审核列表
 */

export function getOrderAuditList(params: AssessmentReportListParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.ORDER_AUDIT_LIST}`,
    method: "post",
    data: params,
  };
  return request(config);
}
/**
 * 审核购买订单
 */
export type AuditOrderParams = {
  id: number;
  auditState: 1 | 2;
  allowance: string;
};
export function auditOrder(params: AuditOrderParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.AUDIT_ORDER}`,
    method: "post",
    data: params,
  };
  return request(config);
}
/**
 * 全部已读
 */
export function readAll() {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.READ_ALL}`,
    method: "post",
  };
  return request(config);
}

/**
 * 查询维度消息接口
 */
export function countNotRead() {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.COUNT_NOT_READ}`,
    method: "post",
  };
  return request(config);
}

/**
 * 查询消息列表
 */
export type MessageListParams = {
  pageNo?: number;
  pageSize?: number;
};
export function getMessageList(params: MessageListParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.MESSAGE_LIST}`,
    method: "post",
    data: params,
  };
  return request(config);
}

/**
 * 删除消息
 */
export type DeleteMessageParams = {
  messageId: string;
};
export function deleteMessage(params: DeleteMessageParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.DELETE_MESSAGE}`,
    method: "post",
    data: params,
  };
  return request(config);
}

/**
 * 已读消息
 */
export type ReadMessageParams = {
  messageId: number;
};
export function readMessage(params: ReadMessageParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.READ_MESSAGE}`,
    method: "post",
    data: params,
  };
  return request(config);
}

/**
 * 更新用户信息
 */
export type UpdateUserInfoParams = {
  id: number;
  name?: string;
  image?: File;
  password?: string;
  updateDescription?: boolean;
  description?: string;
};
export function updateUserInfo(params: UpdateUserInfoParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.UPDATE_USER_INFO}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: params,
  };
  return request(config);
}

/**
 * 查询用户个人信息
 */
export function getUserPersonalInfo() {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.QUERY_USER_PERSONAL_INFO}`,
    method: "post",
  };
  return request(config);
}

/**
 * 审核报告
 */
export type AssessmentReportAuditParams = {
  auditState: number;
  datasetId: number;
  estimateAlgorithmList?: {
    algorithmId?: number;
  }[];
};
export function assessmentReportAudit(params: AssessmentReportAuditParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.ASSESSMENT_REPORT_AUDIT}`,
    method: "post",
    data: params,
  };
  return request(config);
}
/**
 * 查询加密版我的报告数据
 */
export function getMyReport(params: {
  reportId: string | null;
  estimateTaskId: string | null;
}) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.MY_REPORT}`,
    method: "post",
    data: params,
  };
  return request<{
    assessmentReportId: string;
    assessmentMethod: string;
    description: string;
    assessmentReport: string;
    templateHtml: "csv" | "txt" | "video" | "quality-report";
    pattern: string;
  }>(config);
}
/**
 * 退出discourse api
 */
export function quitDiscourse() {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.QUIT_DISCOURSE}`,
    method: "post",
  };
  return request(config);
}
/**
 * 退出casdoor
 */
export function quitSso(sessionId: string) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.QUIT_SSO}`,
    method: "post",
    data: {
      sessionId,
    },
    withCredentials: true,
  };
  return request(config);
}
export type CertificationParams = {
  firmName: string;
  legalName: string;
  taxId: string;
  address: string;
  bankName: string;
  bankAccount: string;
  contactPhone: string;
  businessLicenseImage: File | undefined;
};
export function submitCertification(params: CertificationParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.SUBMIT_CERTIFICATION}`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return request(config);
}
export type CertificationOrderParams = {
  datasetId: string;
  price: string;
  proofFile: File | undefined;
};
export function submitCertificationOrder(params: CertificationOrderParams) {
  const config: AxiosRequestConfig = {
    url: `${url}${UserCenterEnum.SUBMIT_CERTIFICATION_ORDER}`,
    method: "post",
    data: params,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return request(config);
}
